import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "app-report-image-dialog",
  templateUrl: "./report-image-dialog.component.html",
  styleUrls: ["./report-image-dialog.component.scss"],
})
export class ReportImageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ReportImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imagePath: string }
  ) {}

  openNew() {
    window.open(this.data.imagePath);
  }
}
